import { getRecommendationType } from '@pegasus/tracker';
import { tracker } from '../track';
import { formatItemName, formatPrice, formattedSimples, mapArticleToGA4EcommerceItem, toItemAvailability, } from '../../helpers';
export const trackSelectItem = (payload, options) => {
    var _a;
    try {
        const { element, item, itemListName, recommended } = payload;
        tracker.track('GA4-EEC-select_item', {
            event_name: 'select_item',
            select_item: {
                element: element || null,
                item_list_id: null,
                item_list_name: itemListName || null,
                items: [
                    mapArticleToGA4EcommerceItem(Object.assign({ affiliation: String(item.categoryId), discount: item.savings || null, early_access_item: item.plusEarlyAccess ? 1 : 0, index: 0, item_availability: toItemAvailability(item.stockStatus), item_id: item.sku, item_list_name: itemListName || null, item_name: formatItemName(item), item_brand: item.brandCode, item_variant: item.simpleSku || null, is_sustainable: item.sustainable ? 1 : 0, price: formatPrice(item.specialPrice), product_gender: (item.gender || []).toString() || null, promotion_id: item.campaignIdentifier, quantity: item.quantity || null, recommended: getRecommendationType(recommended), size_availability: formattedSimples(item, 'filterValue'), product_delivery_dates: item.deliveryPromise
                            ? `${item.deliveryPromise.beginDate}_${item.deliveryPromise.endDate}`
                            : null }, (_a = options === null || options === void 0 ? void 0 : options.customMapper) === null || _a === void 0 ? void 0 : _a.call(options, item))),
                ],
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `select_item` failed.', e);
    }
};
